<ion-header class="no-shadow">
  <ion-toolbar class="header-background-style" style="position: relative; min-height: 56px;">
    <div style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 1;">
      <img [src]="_appServices._themingService.currentLogo.value.logoUrl" class="header-logo">
    </div>
    <ion-buttons slot="end" style="z-index: 2;">
      <!-- <ion-buttons fill="clear" style="padding: 5px !important;" class="b-1 b-r-4 font-size-22 white-background"
        (click)=_appServices.changelanguageData()>
        <ion-icon name="language-outline" class="color-netral-700"></ion-icon>
      </ion-buttons> -->
      <app-language-toggle></app-language-toggle>
    </ion-buttons>
  </ion-toolbar>
  <ion-progress-bar class="progressbar" type="indeterminate" *ngIf="!isDataLoaded"></ion-progress-bar>
</ion-header>
<div fxLayout="row" fxLayoutAlign="center center" class="end-buttons">
  <app-permission-message class="w-100"></app-permission-message>
</div>
<ion-content class="white-background ion-text-center" #pageTop>
  <div class="ion-text-center loadercenter">
    <ion-spinner color="primary" *ngIf="isDataLoading"></ion-spinner>
  </div>
  <ion-toolbar class="white-background">
    <ion-grid>
      <ion-row>
        <ion-col size="10" class="ion-text-left m-l-10">
          <button mat-button class="go-back-btn full-width-btn" (click)="back_to_inspection(taskId, lat, long)">
            {{ 'self_pwa_text.back_to_inspectin' | translate }}
          </button>
        </ion-col>
      </ion-row>
      <ion-row class="ion-text-center">
        <ion-col size="12">
          <h2 class="inter-medium left-icon m-l-16 font-size-18 ion-text-left color-netral-900">{{
            "common_text.inspection_summary_text" |
            translate }}</h2>
          <p class="inter-regular ion-text-left color-netral-700 m-l-16 m-r-16 font-size-15">
            {{"self_pwa_text.review_start_text" | translate}} {{OrgName}}
            {{"self_pwa_text.review_end_text" | translate}}</p>
        </ion-col>
        <ion-col style="position: absolute;
        text-align: end;
        bottom: 0;">
          <p [class.disabled]="selectedImage && selectedImage.length === 0"
            class="inter-regular font-size-15 m-r-15 m-t-4 m-l-16 back-color ion-text-end m-b-0"
            style="display: inline-block; cursor: pointer;" (click)="deleteConfirmation()">
            <u>
              {{'self_pwa_text.delete_btn' | translate}}
            </u>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>

  <mat-accordion class="dynamic-card-accordian-summary">
    <!-- Accordion For Zone Checklist -->
    <mat-expansion-panel #panel class="expensionPanel  m-10 b-r-8" [expanded]="isChecklistOpen" *ngIf="isZoneQuestion"
      [ngClass]="{ 'pending-header-red': isZoneChecklistError}">
      <link *ngIf="isOpenFeedBackQues" rel="stylesheet" type="text/css" href="/assets/css/bootstrap.min.css">
      <link *ngIf="isOpenFeedBackQues" rel="stylesheet" type="text/css" href="/assets/css/bootstrap-icons.css">
      <mat-expansion-panel-header class="panel-header">
        <span class="panel-title">
          {{"common_text.zone_checklist_text"|translate}}
        </span>
        <!-- <ion-icon *ngIf="isZoneChecklistError && !panel.expanded" name="alert-circle-outline" class="zone-error-icon">
        </ion-icon> -->
      </mat-expansion-panel-header>
      <ion-card [hidden]="!isOpenFeedBackQues">
        <ion-row class="ion-no-paddind ion-text-start">
          <ion-col size="12" class="ion-text-start">
            <app-custom-dynamic-form-builder class="regularFonts" *ngIf="updatedFieldsforCustomForm && taskDetails"
              [customFormJson]="_tempDynamicFormConfig.serverData" [taskDetails]="taskDetails"
              [hiddenSubmitButton]="true" [taskDetails]="taskDetails" [submitEvent]="submitEvent"
              (templateQuesUpdated)="onTemplateQuesUpdated($event)"></app-custom-dynamic-form-builder>
          </ion-col>
        </ion-row>
      </ion-card>
    </mat-expansion-panel>

    <!-- Accordion For Task Checklist -->
    <mat-expansion-panel class="expensionPanel  m-10 b-r-8"
      *ngIf="customTaskChecklist != undefined && customTaskChecklist.length > 0">
      <link *ngIf="isTaskChecklistQues" rel="stylesheet" type="text/css" href="/assets/css/bootstrap.min.css">
      <link *ngIf="isTaskChecklistQues" rel="stylesheet" type="text/css" href="/assets/css/bootstrap-icons.css">
      <mat-expansion-panel-header class="h-48 panel-header-color">
        <mat-panel-title class="text-black mattile inter-medium font-size-17 color-netral-800">
          {{"common_text.task_checklist_text"|translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ion-card [hidden]="!isTaskChecklistQues ">
        <ion-row class="ion-no-paddind ion-text-start">
          <ion-col size="12" class="ion-text-start" *ngIf="customTaskChecklist && taskDetails">
            <app-taskchecklist class="regularFonts" [customTaskChecklist]="customTaskChecklist"
              [taskDetails]="taskDetails" [hiddenSubmitButton]="true" [submitEvent]="submitEvent"></app-taskchecklist>
          </ion-col>
        </ion-row>
      </ion-card>
    </mat-expansion-panel>

    <!-- Accordian For Captured Images & Recomende Images New View-->
    <mat-expansion-panel #panel class="expensionPanel m-10 b-r-8"
      *ngFor="let zone of zoneImageList; let i = index;trackBy: trackByZone" (expandedChange)="onPanelChange($event)"
      [ngClass]="{
        'pending-header-red': zone.validationState === 'mandatory' && _tempDynamicFormConfig.highlightcontrols,
  'pending-header-orange': zone.validationState === 'recommended' && _tempDynamicFormConfig.highlightcontrols
    
  }">
      <mat-expansion-panel-header class="panel-header">

        <!-- LEFT TITLE -->
        <span class="panel-title">
          {{ getZoneName(zone.zoneName.templateId) }}
        </span>

        <!-- RIGHT ERROR ICON -->
        <ion-icon *ngIf="zone.hasMandatory && _tempDynamicFormConfig.highlightcontrols && !panel.expanded"
          name="alert-circle-outline" class="zone-error-icon">
        </ion-icon>

      </mat-expansion-panel-header>

      <!-- Captued Images Card New View-->
      <ng-container *ngIf="!channel">
        <ion-card *ngFor="let control of zone?.uniqueControlIds"
          class="m-10 m-b-10 p-10 white-background card-border border-radius-style">
          <!-- Row for item.label and view more -->
          <div class="ion-text-left" fxLayoutGap="8px">
            <p class="w-100 inter-regular color-netral-900 font-size-16 m-b-10">
              <ng-container *ngFor="let itm of control.selectedTierModels; let i = index">

                <level class="ion-text-left level-item" [ngClass]="{'display-none': (i == 0)}">

                  <!-- Level Label -->
                  {{ (itm?.label ? itm?.label[appSetting.selectedLanguage] : '') | spaceUpperCase }}

                  <!-- Show > separator except last -->
                  <span *ngIf="i !== control.selectedTierModels.length - 1">
                    &nbsp;>&nbsp;
                  </span>

                  <!-- Show star only on last level -->
                  <span *ngIf="i === control.selectedTierModels.length - 1 && itm?.mandatory == 1"
                    class="mandatory-star">
                    *
                  </span>

                  <!-- Show dot only on last level -->
                  <!-- <span *ngIf="i === control.selectedTierModels.length - 1 && itm?.mandatory == 2"
                  class="recommended-dot">
                </span> -->
                  <span *ngIf="i === control.selectedTierModels.length - 1 && itm?.mandatory == 2"
                    style="color:#EAA13C; font-size:14px;">●</span>

                </level>

              </ng-container>

            </p>

          </div>
          <!-- Row for images -->
          <div fxLayout="row" fxLayoutAlign="start center">
            <div fxLayout="row wrap" fxLayoutGap="10px" fxFlex="100" class="image-container" class="image-container">
              <ng-container
                *ngFor="let imgDetails of getFilteredImages(zone.zoneImages, control.controlId); let j = index">
                <ng-container *ngIf="viewMoreState[control.controlId] || j < 3">
                  <div class="image-checkbox-container">
                    <ion-checkbox class="image-checkbox" mode="md"
                      (ionChange)="checkedUnchecked(imgDetails,$event)"></ion-checkbox>

                    <!-- Images -->
                    <ion-img class="summary_card_left_img-local" *ngIf="imgDetails.FileType == 'images'"
                      [src]="imgDetails.localFileUrl" (click)="gotoPhotoMetaTag(imgDetails)"
                      onerror="this.src='assets/images/default-camera-image.jpg'">
                    </ion-img>

                    <!-- Videos -->
                    <ion-img class="summary_card_left_img-local" *ngIf="imgDetails.FileType == 'videos'"
                      src="../../../../assets/images/videoThumbnail.png" (click)="gotoPhotoMetaTag(imgDetails)">
                    </ion-img>

                    <!-- Files -->
                    <ion-img class="summary_card_left_img-local" *ngIf="imgDetails.FileType=='files'"
                      (click)="gotoPhotoMetaTag(imgDetails)"
                      [src]="_appServices.showFileThumbnail(imgDetails.FileName)">
                    </ion-img>
                  </div>
                </ng-container>
              </ng-container>

              <!-- Show "more images" only once -->
              <ng-container
                *ngIf="!viewMoreState[control.controlId] && getFilteredImages(zone.zoneImages, control.controlId).length > 3">
                <div class="more-image-icon" (click)="toggleViewMore(control.controlId)">
                  +{{ getFilteredImages(zone.zoneImages, control.controlId).length - 3 }}
                </div>
              </ng-container>

            </div>
          </div>
        </ion-card>
      </ng-container>

      <!-- Captured Images Card Old View -->
      <ng-container *ngIf="channel">
        <ion-card *ngFor="let imgDetails of zone?.zoneImages"
          class="m-10 m-b-10 p-10 white-background card-border border-radius-style">
          <!-- Row for item.label and view more -->
          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
            <p class="w-100 inter-regular color-netral-900 font-size-16 m-b-10" fxLayout="row"
              fxLayoutAlign="start center">
              <level class="ion-text-left" style="white-space: nowrap;"
                *ngFor=" let itm of imgDetails.selectedTierModels; let i=index" [ngClass]="{'display-none': (i == 0)}">
                {{(itm?.label ? itm?.label[appSetting.selectedLanguage] : '') | spaceUpperCase}}
                <span [ngClass]="{'display-none': i == imgDetails.selectedTierModels.length-1}"> ></span>&nbsp;
              </level>
              <span *ngIf="imgDetails?.mandatory == 1" class="mandatory-star">*</span>
              <!-- <span *ngIf="imgDetails?.mandatory == 2" class="recommended-dot"></span> -->
              <span *ngIf="imgDetails?.mandatory == 2" style="color:#EAA13C; font-size:14px;">●</span>
            </p>
          </div>
          <!-- Row for images -->
          <div fxLayout="row" fxLayoutAlign="space-evenly none">
            <!-- <div fxLayout="row wrap" fxLayoutGap="10px" fxFlex="100" class="image-container" class="image-container"> -->
            <div fxFlex="30">
              <div class="image-checkbox-container">
                <ion-checkbox class="image-checkbox" mode="md"
                  (ionChange)="checkedUnchecked(imgDetails,$event)"></ion-checkbox>
                <ion-thumbnail>
                  <img alt="Silhouette of mountains" *ngIf="imgDetails && imgDetails.FileType == 'images'"
                    [src]='imgDetails.localFileUrl' (click)="gotoPhotoMetaTag(imgDetails)"
                    onerror="this.src='assets/images/default-camera-image.jpg'" />
                  <img class="summary_card_left_img-local" *ngIf="imgDetails &&  imgDetails.FileType == 'videos'"
                    src='../../../../assets/images/videoThumbnail.png' (click)="gotoPhotoMetaTag(imgDetails)" />
                  <img *ngIf="imgDetails && imgDetails.FileType=='files'" class="summary_card_left_img-local"
                    [src]="_appServices.showFileThumbnail(imgDetails.FileName)"
                    (click)="gotoPhotoMetaTag(imgDetails)" />
                </ion-thumbnail>
              </div>
            </div>
            <div fxFlex="64" class="ion-text-left">
              <p class="siteview primary-color w-100 inter-bold font-size-20" *ngIf="imgDetails.FileType == 'files'">
                {{ imgDetails?.originalFileName | slice: 0: 20 }}
                <span *ngIf="imgDetails?.originalFileName?.length > 20">...</span>
              </p>
              <p class="tagsitem w-100" [hidden]="imgDetails.FileType == 'files'">
                <ion-text class="color-netral-900 inter-medium font-size-16">
                  {{"native_text.tags_text" | translate}}
                </ion-text>
                :
                <span class="inter-regular font-size-16">
                  {{!showFullText && formatMetaData(imgDetails?.MetaData)?.length > 40
                  ? formatMetaData(imgDetails?.MetaData)?.slice(0, 40)
                  : formatMetaData(imgDetails?.MetaData)}}
                </span>
                <ion-text class="primary-color" *ngIf="formatMetaData(imgDetails?.MetaData)?.length > 40"
                  (click)="showFullText = !showFullText">
                  {{showFullText ? ' Show Less' : '...'}}
                </ion-text>
              </p>

              <p class="tagsitem w-100">
                <ion-text class="color-netral-900 inter-medium font-size-16">
                  {{"native_text.observation_text" | translate}}:
                </ion-text>
                <span class="inter-regular font-size-16">
                  {{!showFullObservation && imgDetails?.observationText?.length > 40
                  ? imgDetails?.observationText.slice(0, 40)
                  : imgDetails?.observationText}}
                </span>
                <ion-text *ngIf="imgDetails?.observationText?.length > 40" class="primary-color"
                  (click)="showFullObservation = !showFullObservation">
                  {{showFullObservation ? ' Show Less' : '...'}}
                </ion-text>
              </p>
            </div>
          </div>
        </ion-card>
      </ng-container>


      <!-- Non Captured Images Card -->
      <ion-card *ngFor="let validationCat of zone.reconmendedControlList" class="m-b-0 card-border border-radius-style"
        [ngClass]="{'media-error-red': validationCat?.mandatory == 1 && _tempDynamicFormConfig.highlightcontrols, 'media-error-orange': validationCat?.mandatory == 2 && _tempDynamicFormConfig.highlightcontrols 
 }">
        <ion-icon *ngIf="validationCat?.mandatory == 1 && _tempDynamicFormConfig.highlightcontrols"
          name="alert-circle-outline" class="tier-error-icon">
        </ion-icon>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <p class="inter-regular color-netral-900 font-size-16  m-10"><span
              *ngFor="let itm of validationCat.selectedTierModels;let i=index"
              [ngClass]="{'display-none': i==0}">{{(itm?.label ? itm?.label[appSetting.selectedLanguage] : '') |
              spaceUpperCase}}
              <span [ngClass]="{'display-none': i == validationCat.selectedTierModels.length-1}"> > </span>
            </span>
            <span *ngIf="validationCat?.mandatory == 1" class="mandatory-star">*</span>
            <span *ngIf="validationCat?.mandatory == 2" style="color:#EAA13C; font-size:14px;">●</span>
          </p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="content-section">
          <!-- Text Section -->
          <div fxLayout="column" fxLayoutAlign="center center" class="text-section">
            <ion-icon name="close-outline" class="font-size-22"></ion-icon>
            <p class="inter-regular color-netral-800 font-size-16">{{'self_pwa_text.no_data_uploaded' | translate}}</p>
            <a (click)="goToInspectionFormFill(validationCat, zone.zoneName.templateId)"
              class="upload-media-link back-color inter-regular font-size-16"><u>{{validationCat.controlType == 'files'
                ? 'Upload Document' : validationCat.controlType == 'videos' ? 'Capture Video' : 'Take Photo'}}</u></a>
          </div>
        </div>
      </ion-card>

    </mat-expansion-panel>
  </mat-accordion>
</ion-content>

<ion-footer class="white-background ion-text-center footer-style-summary">
  <ion-row>
    <!-- <ion-col size="6">
      <ion-button expand="block" size="large" [disabled]="isDataLoading"
        class="nobackground font-size-16 inter-medium  show-fulltext h-48 t-c letter-spacing-normal"
        (click)="saveandsubmitlater()">{{
        "common_btn_text.save_finish_btn" | translate }}</ion-button>
    </ion-col> -->
    <!-- class="ion-text-right" -->
    <ion-col size="12">
      <ion-button expand="block" size="large" [disabled]="isDataLoading"
        class="loginbtn font-size-16 inter-medium  show-fulltext h-48 t-c letter-spacing-normal"
        (click)="confirmationSave()">{{
        "common_btn_text.inspection_submit_btn" | translate }} <ion-spinner name="lines" class="validatespinner1"
          *ngIf="ShowSpinner"></ion-spinner></ion-button>
    </ion-col>
  </ion-row>
</ion-footer>